import { render, staticRenderFns } from "./SwipeActions.vue?vue&type=template&id=01def123&"
import script from "./SwipeActions.vue?vue&type=script&lang=js&"
export * from "./SwipeActions.vue?vue&type=script&lang=js&"
import style0 from "./SwipeActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports